import React from "react";
import siteConfig from "../siteConfig";

function BrandMark({ compact = false }) {
  return (
    <span className={`wordmark-lockup ${compact ? "is-compact" : ""}`}>
      <span className="wordmark-symbol" aria-hidden="true">
        <svg viewBox="0 0 48 48">
          <path d="M12 8v32M36 8v32M12 24h24" />
          <path className="wordmark-orbit" d="M6 24c5-9 13-14 18-14s13 5 18 14c-5 9-13 14-18 14S11 33 6 24Z" />
          <circle cx="24" cy="24" r="2.8" />
        </svg>
      </span>
      <span className="wordmark-text">{siteConfig.wordmark}</span>
    </span>
  );
}

export default BrandMark;
